import { Lib } from "albertine-shared-web";
import classNames from "classnames";
import type React from "react";
import type { ReactNode } from "react";
import "./Card.css";

export type CardProps = {
    /**
     * The content to be displayed inside the card
     */
    children: ReactNode;
    /**
     * Optional CSS class name
     */
    className?: string;
    /**
     * Optional inline styles
     */
    style?: React.CSSProperties;
    /**
     * Optional click handler
     */
    onClick?: (e: React.MouseEvent) => void;
};

/**
 * Card component with configurable content, icon, and styling.
 * Based on the design specifications with rounded corners, shadow and white background.
 */
export function Card({ children, className, style, onClick }: CardProps) {
    return (
        <div className={classNames("card", className)} style={style} onClick={onClick}>
            <Lib.Flex.Column>
                <div className="card__content">{children}</div>
            </Lib.Flex.Column>
        </div>
    );
}
